import styled from 'styled-components';
import Link from 'next/link';
import { Typography } from '../../ui/Typography';
import { FlexCenterAligned, FlexColumn } from '../../../styled/common';
import { getSafeAreaValue } from '../../../styled/theme/helpers/getSafeAreaValue';

export const LayoutContainer = styled(FlexColumn)`
  width: 100%;
  height: 100vh;
  padding: 20px 10px ${({ theme }) => getSafeAreaValue(theme, 'bottom', 20)};
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    height: 100svh;
  }

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 20px;
  }

  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    flex-direction: row;
    justify-content: center;
    gap: 20px;
  }
`;

export const ImageBlock = styled.div`
  display: none;
  width: 470px;
  height: 100%;
  background-image: url('/static/images/auth/banner-1x.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 16px;

  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    display: block;
  }

  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    background-image: url('/static/images/auth/banner-2x.jpg');
  }
`;

export const ContentBlock = styled(FlexColumn)`
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 30px;
  padding: 20px;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 20px 40px;
    border-radius: 28px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 45px;
  position: relative;

  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    justify-content: center;
  }

  > svg {
    height: 15px;
    width: 15px;

    @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
      height: 18px;
      width: 18px;
    }

    @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
      position: absolute;
      right: 10px;
      left: auto;
    }
  }
`;

export const FormContainer = styled(FlexCenterAligned)`
  flex: 1;
  flex-direction: column;
  box-sizing: border-box;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 373px;
    margin: auto;
  }
`;

export const Footer = styled(Typography)`
  text-align: center;
  color: #bcbcbc;
`;

export const FooterLink = styled(Link)`
  color: #bcbcbc;
  font-size: 15px;
  cursor: pointer;
`;
